import { render, staticRenderFns } from "./TargetEmail.vue?vue&type=template&id=87eccaae&scoped=true"
import script from "./TargetEmail.vue?vue&type=script&lang=js"
export * from "./TargetEmail.vue?vue&type=script&lang=js"
import style0 from "./TargetEmail.vue?vue&type=style&index=0&id=87eccaae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87eccaae",
  null
  
)

export default component.exports